/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlFamilyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceControlFamilyQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceControlFamilyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlFamilyQueryOperator>): ComplianceControlFamilyQueryOperator {
        let obj = Object.assign(new ComplianceControlFamilyQueryOperator(), model);
        ComplianceControlFamilyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlFamilyQueryOperator>): ComplianceControlFamilyQueryOperator {
        if (!model) return null;
        return ComplianceControlFamilyQueryOperator.newInstance(<ComplianceControlFamilyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlFamilyQueryOperator) {
        if (!obj) return;

        models.ComplianceControlFamilyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlFamilyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceControlFamilyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Control families to include
     */
    control_families: Array<string>;

}
